import React from 'react';
import FlexGrid from '@tds/core-flex-grid';
import Box from '@tds/core-box';
import { HeaderBar, LogoBar } from '../../styles/header';

import Logo from './logo';
import { HeaderLinks, Link } from '../../styles/elements';
import { languageTypes, registrationPathNames } from '../../config/constants';

const getPageNameWithoutLocale = () => {
  const pathname = window.location.pathname;
  const queryParam = window.location.search;
  const [, pageName] = pathname.substr(1, pathname.length).split('/');
  if (pathname === registrationPathNames.fr || pathname === registrationPathNames.en) {
    return (pageName && `${pageName}`) || '';
  }
  return (pageName && `${pageName}${queryParam}`) || '';
};

const Header = () => {
  const pageName = getPageNameWithoutLocale();
  return (
    <Box>
      <HeaderBar>
        <FlexGrid limitWidth>
          <FlexGrid.Row>
            <Box inset={3}>
              <LogoBar>
                <Logo height='58px' />
              </LogoBar>
            </Box>
            <HeaderLinks>
              <Link to={`/${languageTypes.en}/${pageName}`}>En</Link>
              &nbsp; | &nbsp;
              <Link to={`/${languageTypes.fr}/${pageName}`}>Fr</Link>
            </HeaderLinks>
          </FlexGrid.Row>
        </FlexGrid>
      </HeaderBar>
    </Box>
  );
};

export default Header;
